import {
  Button,
  ButtonProps,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useRef, useState } from "react";
import { Else, If, Then } from "react-if";
import { InlineWidget } from "react-calendly";
import ReCAPTCHA from "react-google-recaptcha";
import { useShowErrorToast } from "@modules/Layout/hooks/useSubmitRequestContact";

interface IProps extends ButtonProps {
  label?: string;
  children?: React.ReactNode;
  isOpen: boolean;
  onOpenModal: () => void;
  onCloseModal: () => void;
}

const CalendlyButton: React.FC<IProps> = ({
  label = "Schedule Demo",
  children,
  variant = "primary",
  isOpen,
  onOpenModal,
  onCloseModal,
  ...rest
}) => {
  const recaptchaV2Key = process.env.GATSBY_RECAPTCHA_V2_SITE_KEY || "";
  const reCaptchaRef = useRef(null);
  const scheduleEvent = process.env.GATSBY_CALENDLY || "";
  const [recaptchaPassed, setRecaptchaPassed] = useState<boolean>(false);

  const errorToast = useShowErrorToast();
  const handleButtonClick = () => {
    onOpenModal();
  };

  const handleClosePopup = () => {
    setRecaptchaPassed(false);
    onCloseModal();
  };

  const handleChangeRecaptcha = (value: string | null) => {
    if (value) {
      setRecaptchaPassed(true);
    } else {
      errorToast(
        "We are unable to verify you as a human. Please try again later."
      );
    }
  };

  return (
    <>
      <Button
        textStyle={"hind_m"}
        variant={variant}
        onClick={handleButtonClick}
        {...rest}
      >
        {children || label}
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={handleClosePopup}
        isCentered
        size={"auto"}
      >
        <ModalOverlay />

        <ModalContent width={{ base: "100%", lg: "80vw" }}>
          <ModalHeader>
            <Text color={"primary700"} textAlign={"center"}>
              {label}
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <If condition={recaptchaPassed}>
              <Then>
                <InlineWidget
                  url={scheduleEvent}
                  styles={{
                    height: "800px",
                    marginTop: 0,
                  }}
                  pageSettings={{
                    backgroundColor: "ffffff",
                    hideEventTypeDetails: false,
                    hideLandingPageDetails: false,
                    primaryColor: "00a2ff",
                    textColor: "4d5055",
                  }}
                />
              </Then>
              <Else>
                <Center mb={5}>
                  <ReCAPTCHA
                    style={{ display: "inline-block" }}
                    theme="dark"
                    ref={reCaptchaRef}
                    sitekey={recaptchaV2Key}
                    onChange={handleChangeRecaptcha}
                  />
                </Center>
              </Else>
            </If>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CalendlyButton;
